import React from "react";
import { useNavigate } from "react-router-dom";
import { useNotifications } from "../../context/NotificationContext";

const NotificationsPage = () => {
  const navigate = useNavigate();
  const { notifications } = useNotifications();

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">
        Notifications
      </h1>

      {notifications.length === 0 ? (
        <div className="p-6 bg-gray-50 text-center rounded-xl shadow">
          <p className="text-gray-600">You have no notifications.</p>
        </div>
      ) : (
        <div className="space-y-5">
          {notifications.map((noti) => (
            <div
              key={noti._id}
              onClick={() => noti.actionUrl && navigate(noti.actionUrl)}
              className={`p-6 rounded-xl border shadow-sm transition-all bg-white hover:shadow-md hover:translate-y-[-2px] ${
                noti.actionUrl ? "cursor-pointer" : ""
              } ${
                !noti.isRead ? "border-blue-300 bg-blue-50/30" : "border-gray-200"
              }`}
            >
              {/* Title */}
              <h2 className="text-xl font-semibold text-gray-900">
                {noti.title}
              </h2>

              {/* Message */}
              <p className="text-gray-700 mt-1">{noti.message}</p>

              {/* Timestamp */}
              <p className="text-gray-500 text-sm mt-3">
                {new Date(noti.createdAt).toLocaleString("en-IN", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default NotificationsPage;
